<template>
  <div class="container py-5">

    <div class="columns" v-if="!firstLoad">
      <div class="column is-one-fifth">
        <label class="label">Storage Code</label>
        <div>{{ storage.storage_code }}</div>
      </div>

      <div class="column is-one-fifth">
        <label class="label">Storage Name</label>
        <v-text-field 
          required
          placeholder="Storage Name"
          v-model="storage.storage_name"
          @blur="updateStorage({
            storageId: storage.id,
            data: {
              storage_name: $event
            }
          })"/>
      </div>

      <div class="column is-one-fifth">
        <label class="label">Storage Type</label>
        <div>{{ storage.storage_type.storage_type_name }}</div>
      </div>

      <div class="column is-one-fifth">
        <label class="label">Warehouse</label>
        <!-- <template v-if="storage.warehouse_location">
          <div class="is-size-7">
            {{ storage.warehouse_location.warehouse.warehouse_code }}
          </div>
          <div>
            {{ storage.warehouse_location.warehouse.warehouse_name }}
          </div>
        </template> -->
        <v-select 
          v-if="warehouses"
          :options="warehouses"
          :item-text="v => `${v.warehouse_code} - ${v.warehouse_name}`"
          item-value="id"
          v-model="storage.warehouse_location.warehouse_id"
        />
      </div>

      <div class="column is-one-fifth">
        <label class="label">Warehouse Space</label>
        <v-select 
          v-if="warehouse"
          :options="warehouse.locations"
          :item-text="v => `${v.location_code} - ${v.location_name}`"
          item-value="id"
          v-model="storage.warehouse_location_id"
          @input="updateStorage({
            storageId: storage.id,
            data: {
              warehouse_location_id: $event
            }
          })"
        />
        <span v-else class="has-text-grey-light">
          Please select a warehouse
        </span>
      </div>
    </div>

    <hr/>

    <div>
      <div class="level">
        <div class="subtitle mb-0">
          Storage Items
        </div>
        <button 
          class="button is-small is-primary"
          @click="addingItems = true">
          Add Items to Storage
        </button>
      </div>

      <article 
        v-if="!firstLoad && storage.storage_units.length == 0" 
        class="message is-info is-fullwidth">
        <div class="message-body">
          There are no items in this storage
        </div>
      </article>

      <table 
        v-if="!firstLoad && storage.storage_units.length > 0" 
        class="table is-fullwidth">
        <thead>
          <tr>
            <th 
              v-for="(header, headerIndex) in headers"
              :key="headerIndex">
              {{ header.label }}
            </th>
            <th v-if="editable"></th>
          </tr>
        </thead>
        <tbody>
          <tr               
            class="v-centered"
            v-for="unit in storage.storage_units"
            :key="unit.id">
            <td>
              {{ unit.stocking_unit.product_master.product_category.category }}
            </td>
            <td>
              <span v-if="unit.stocking_unit.product_master.product_subcategory">
                {{ unit.stocking_unit.product_master.product_subcategory.subcategory }}
              </span>
              <span class="has-text-grey-light" v-else>
                No product subcategory
              </span>
            </td>
            <td>
              <span>
                {{ unit.stocking_unit.product_master.name }}
              </span>
              <div class="help">
                <span v-if="unit.stocking_unit.product_master.product_category.has_dimensions">
                  {{ lwt(unit.stocking_unit) }}
                </span>
                <span v-else>
                  {{ unit.stocking_unit.product_master.size }}
                </span>
              </div>
            </td>
            <td>
              {{ unit.qty }}
            </td>
            <td>
              {{ unit.stocking_unit.product_master.unit ? 
                unit.stocking_unit.product_master.unit.name : '' }}
            </td>
            <td v-if="editable">
              <div class="buttons buttons-right">
                <button
                  @click="removePart(part.id)" 
                  class="button is-small">
                  <span class="icon">
                    <i class="fas fa-trash has-text-grey">
                    </i>
                  </span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <add-storage-items-modal 
        v-if="storage"
        v-model="addingItems"
        :current-items="itemIds"
        :storage-id="storage.id"
        :project-id="storage.project_id"/>

    </div>

  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import AddStorageItemsModal from '@/components/cutsheet/AddStorageItemsModal'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    VSelect, VTextField, AddStorageItemsModal
  },
  data() {
    return {
      headers: [
        { label: 'Product Category' },
        { label: 'Product Subcategory' },
        { label: 'Product'},
        { label: 'Quantity' },
        { label: 'Unit'}
      ],
      addingItems: false
    }
  },
  computed: {
    ...mapState("storage", ["storage", "firstLoad"]),
    ...mapState("warehouses", ["warehouses"]),
    editable() {
      return true
    },
    itemIds() {
      return this.storage.storage_units.map(d => d.stocking_unit_id);
    },
    warehouse() {
      return this.warehouses.filter(
        d => d.id == this.storage.warehouse_location.warehouse_id
      )[0];
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("storage", ["getStorage", "updateStorage"]),
    ...mapMutations("storage", ["setStorage", "setLoading", "setFirstLoad"]),
    ...mapActions("warehouses", ["getWarehouses"]),
    ...mapMutations("app", ["setNotification"]),
    initialize() {
      if (this.$route.params.storage) {
        this.setStorage(this.$route.params.storage);
        this.setLoading(false);
        this.setFirstLoad(false);
      } else {
        this.getStorage(this.$route.params.storageId);
      }

      if (this.warehouses.length == 0) {
        this.getWarehouses();
      }
    },
    lwt(product) {
      if (product) {
        return `L${product.length_in_str}" x W${product.width_in_str}" x T${product.thick_in_str}"`
      }
    },
    ///this.addStorageUnit({
      //   storage_id: resp.data.id,
      //   stocking_unit_id: part.output_stocking_unit.id,
      //   qty: parseInt(part.quantity)
      // })
    // removePart(partId) {
    //   this.deletePart({ skidId: this.skid.id, partId: partId })
    //     .then(() => this.notifySuccess());
    // },
    notifySuccess() {
      this.setNotification({ 
        status: true, 
        type: 'success',
        message: 'Part successfully removed from skid'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>